// import { exp } from '@techstark/opencv-js'
import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/BookedCourse/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/BookedCourse/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/BookedCourse/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/BookedCourse/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/BookedCourse/Delete',
    method: 'delete',
    data,
  })
}

export function cancel(data) {
  return request({
    url: '/BookedCourse/Cancel',
    method: 'Post',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/BookedCourse/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function ListStudent() {
  return request({
    url: '/BookedCourse/ListStudent',
    method: 'post',
  })
}

export function assignNewCoach(data) {
  return request({
    url: '/BookedCourse/AssignNewCoach',
    method: 'post',
    data,
  })
}

export function listBookingTransfers(data) {
  return request({
    url: '/BookedCourse/listBookingTransfers',
    method: 'post',
    data,
  })
}

export function cancelBookingTransfer(data) {
  return request({
    url: '/BookedCourse/CancelBookingTransfer',
    method: 'post',
    data,
  })
}

export function updateAbnormalAttendanceReason(data) {
  return request({
    url: '/BookedCourse/UpdateAbnormalAttendanceReason',
    method: 'post',
    data,
  })
}

export function listAvailableCoach(data) {
  return request({
    url: '/BookedCourse/ListAvailableCoach',
    method: 'post',
    data,
  })
}

export function isAssignedCoach() {
  return request({
    url: '/BookedCourse/IsAssignedCoach',
    method: 'post',
  })
}

export function listStudentBooking(data) {
  return request({
    url: '/BookedCourse/ListStudentBooking',
    method: 'post',
    data,
  })
}

export function acceptBookingTransfer(data) {
  return request({
    url: '/BookedCourse/AcceptBookingTransfer',
    method: 'post',
    data,
  })
}

export function rejectBookingTransfer(data) {
  return request({
    url: '/BookedCourse/RejectBookingTransfer',
    method: 'post',
    data,
  })
}

export function getBookingTransfer(data) {
  return request({
    url: '/BookedCourse/GetBookingTransfer',
    method: 'post',
    data,
  })
}

export function listCoachCenter() {
  return request({
    url: '/BookedCourse/ListCoachCenter',
    method: 'post',
  })
}

export function getHighlight(data) {
  return request({
    url: '/BookedCourse/GetHighlight',
    method: 'post',
    data,
  })
}

export function listInsiteCoach(data) {
  return request({
    url: '/BookedCourse/ListInsiteCoach',
    method: 'post',
    data,
  })
}

export function showExcel(data) {
  return request({
    url: '/BookedCourse/BookingTransferExcel',
    method: 'post',
    data,
  })
}
